
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 11.667c0-1.459.348-2.757 1.042-3.896.694-1.14 1.458-2.097 2.292-2.875.833-.778 1.597-1.372 2.291-1.782L10 2.5v2.75c0 .514.174.92.52 1.218.348.299.737.448 1.168.449.236 0 .461-.049.677-.146a1.64 1.64 0 00.593-.48l.375-.458A6.694 6.694 0 0115.75 8.26a6.575 6.575 0 01.917 3.407c0 1.222-.299 2.337-.896 3.344a6.723 6.723 0 01-2.354 2.384 4.16 4.16 0 00.552-1.094c.132-.396.198-.816.198-1.26 0-.555-.104-1.08-.313-1.573a4.12 4.12 0 00-.896-1.322L10 9.25l-2.937 2.896a4.245 4.245 0 00-.917 1.333 3.924 3.924 0 00-.313 1.563c0 .444.066.864.199 1.26.132.397.316.761.551 1.094A6.737 6.737 0 014.23 15.01c-.597-1.007-.896-2.122-.896-3.343zM10 11.583l1.77 1.73c.237.236.418.5.543.791.124.292.187.604.187.938 0 .68-.243 1.26-.73 1.739A2.433 2.433 0 0110 17.5c-.694 0-1.285-.24-1.77-.72a2.353 2.353 0 01-.73-1.738c0-.32.063-.629.188-.928.125-.299.305-.566.541-.802L10 11.584z","fill":"#FF8743"}})])
          )
        }
      }
    